import React, { useEffect, useState, useRef  } from "react";
import styled from "styled-components";
import axios from "axios";
import { useLanguage } from "./LanguageContext";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { api } from "../lib/http";

const API_BASE_URL = "https://shopaholics.ge/api";

const SliderContainer = styled.div`
  max-width: 1200px;
  overflow: hidden;
  width: 100%;
  position: relative;
  padding: 30px 0;
  align-self: center;
  justify-self: center;
  border-top: 1px solid rgb(238, 238, 238);
`;

const SlideWrapper = styled.div`
  display: flex;
  transition: transform 0.5s ease-in-out;
  transform: translateX(${({ current }) => `-${current * 100}%`});
  max-width: 400px;
`;

const Slide = styled.div`
  flex: 0 0 100%;
  padding: 20px;
  box-sizing: border-box;
`;

const ReviewBox = styled.div`
  background: white;
  max-width: 800px;
  margin: auto;
  padding: 20px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
    img {
    width: 50px;
    height: 50px;
    object-fit: cover;
    border-radius: 5px;
  }

`;

const Stars = styled.div`
  font-size: 1.2rem;
  color: black;
`;

const Author = styled.div`
  font-size: 0.8rem;
  color: #666666;
  font-weight: 500;
`;


const ProductName = styled.a`
  font-weight: bold;
  color: #333333;
  font-size: 0.9rem;
  text-decoration: none;
  cursor: pointer;

`;


const ReviewText = styled.div`
  font-size: 0.8rem;
  color: rgb(145, 145, 145);
  font-weight: 500;
  line-height: 1.4em;
  max-height: 4.2em; /* ~3 lines */
  overflow: hidden;
  position: relative;

  .text {
    display: -webkit-box;
    -webkit-line-clamp: 3; /* ✅ Show only 3 lines */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal; /* ✅ Allow line breaks */
    word-break: break-word; /* ✅ Break long words */
  }

  a {
    font-size: 0.75rem;
    color: #007bff;
    font-weight: bold;
    display: inline-block;
    margin-top: 5px;
    text-decoration: none;
  }
`;

const ArrowButton = styled.button`
  position: absolute;
  top: 50%;
  ${({ direction }) => direction === "left" ? "left: -15px;" : "right: -15px;"}
  transform: translateY(-50%);
  height: 100px;
  border-radius: 0px;
  border: none;
  background-color: white;
  border-right: none;
  width: 50px;
  color: rgb(50, 50, 50);
  z-index: 10;
  cursor: pointer;
  transition: background 0.3s ease;


  @media (max-width: 600px) {
    background-color: transparent;
    &:hover {
        background: transparent;
    }
    ${({ direction }) => direction === "left" ? "left: -15px;" : "right: -15px;"}
      border: none;

  }
      
`;

const ReviewTextWrapper = styled.div`
  position: relative;
  font-size: 0.85rem;
  color: #555;
`;

const TruncatedText = styled.span`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-word;
  max-height: 4.2em;
`;

const ReadMore = styled.span`
  color:rgb(155, 70, 39);
  font-weight: 500;
  cursor: pointer;
  display: inline-block;
`;


const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

const ModalContent = styled.div`
  background: white;
  padding: 30px;
  border-radius: 12px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 8px 20px rgba(0,0,0,0.25);
  position: relative;
  word-break: break-word;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 8px;
  right: 12px;
  background: none;
  border: none;
  font-size: 1.2rem;
  color: #777;
  cursor: pointer;
`;


const ReviewTextWithPopup = ({ review, onClick }) => {
  const textRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (el && el.scrollHeight > el.clientHeight + 1) {
      setIsOverflowing(true);
    }
  }, []);

  return (
    <ReviewTextWrapper>
      <TruncatedText ref={textRef}>{review.review_text}</TruncatedText>
      {isOverflowing && (
        <ReadMore onClick={() => onClick(review)}>
          Read more
        </ReadMore>
      )}
    </ReviewTextWrapper>
  );
};


const LatestReviews = () => {
  const [reviews, setReviews] = useState([]);
  const [current, setCurrent] = useState(0);
  const { t } = useLanguage();
  const [modalReview, setModalReview] = useState(null);

  const handleCloseModal = () => setModalReview(null);
  
  useEffect(() => {
    api.get(`${API_BASE_URL}/get_latest_reviews.php`)
      .then((res) => {
        if (Array.isArray(res.data)) {
          setReviews(res.data.slice(0, 10));
        }
      })
      .catch((err) => {
        console.error("❌ Error fetching latest reviews:", err);
      });
  }, []);

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % reviews.length);
  };

  const prevSlide = () => {
    setCurrent((prev) => (prev - 1 + reviews.length) % reviews.length);
  };
  

  return (
    <div className="review-container">
    <h2>{t("review.title")}</h2>
    <SliderContainer>
      {reviews.length > 0 && (
        <>
          <ArrowButton direction="left" onClick={prevSlide}>
            <FaChevronLeft />
          </ArrowButton>
          <ArrowButton direction="right" onClick={nextSlide}>
            <FaChevronRight />
          </ArrowButton>
        </>
      )}
      <SlideWrapper current={current}>
        {reviews.map((review, i) => (
          <Slide key={i}>
            <ReviewBox>
              <Stars>{"★".repeat(review.stars) + "☆".repeat(5 - review.stars)}</Stars>
              <Author>{review.username} • {new Date(review.created_at).toLocaleDateString()}</Author>
              <ProductName
                href={`/product/${review.product_id}`}
              >
                {review.name_en ? review[t("detailed.name")] : review.name}
              </ProductName>
              <div className="review-image">
                {review.image_url && <img src={review.image_url} alt={review.product_name} />}
                <ReviewTextWithPopup
                  review={review}
                  onClick={(review) => setModalReview(review)}
                />
                </div>
            </ReviewBox>
          </Slide>
        ))}
      </SlideWrapper>
    </SliderContainer>
    {modalReview && (
      <ModalOverlay onClick={handleCloseModal}>
        <ModalContent onClick={(e) => e.stopPropagation()}>
          <CloseButton onClick={handleCloseModal}>×</CloseButton>
          <Stars>{"★".repeat(modalReview.stars) + "☆".repeat(5 - modalReview.stars)}</Stars>
          <Author>{modalReview.username} • {new Date(modalReview.created_at).toLocaleDateString()}</Author>
          <ProductName
          href={`/product/${modalReview.product_id}`}
        >
        {modalReview.name_en ? modalReview[t("detailed.name")] : modalReview.name}
        </ProductName>
          <p style={{ marginTop: "15px", fontSize: "0.9rem", color: "#444", lineHeight: "1.6" }}>
            {modalReview.review_text}
          </p>
        </ModalContent>
      </ModalOverlay>
    )}
    </div>
  );
};

export default LatestReviews;
